import { css } from "@emotion/css";
import { ExternalLink, PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { fontFamily, fontSize, fontWeight, lineHeight, space } from "@octopusdeploy/design-system-tokens";
import { useMemo } from "react";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
import { useThemePaletteType } from "~/components/Theme/useThemePaletteType";
import HelmImageReplacePathDarkModeHelpImage from "./HelmImageReplacePathHelpDarkModeImage.svg";
import HelmImageReplacePathLightModeHelpImage from "./HelmImageReplacePathHelpLightModeImage.svg";
const styles = {
    description: css({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: space[8],
        alignSelf: "stretch",
    }),
    title: css({
        fontSize: fontSize.base,
        fontWeight: fontWeight[700],
        lineHeight: lineHeight.small,
    }),
    descriptionText: css({
        fontSize: fontSize.medium,
        fontWeight: fontWeight[400],
        lineHeight: lineHeight.xSmall,
    }),
    descriptionCodeText: css({
        fontFamily: fontFamily.code,
        fontSize: fontSize.medium,
        lineHeight: lineHeight.xSmall,
    }),
};
export function HelmImageReplacePathPopover() {
    const paletteType = useThemePaletteType();
    const helpImage = useMemo(() => (paletteType === "dark" ? HelmImageReplacePathDarkModeHelpImage : HelmImageReplacePathLightModeHelpImage), [paletteType]);
    return (<PopoverBasicHelp placement="top-start" width="narrow" image={helpImage} link1={<ExternalLink href={ExternalLinkSlugs.AnnotationsDocs}>Docs</ExternalLink>} description={<div className={styles.description}>
                    <div className={styles.title}>Find your image tag path</div>
                    <p className={styles.descriptionText}>
                        The path depends on how your Helm chart's <span className={styles.descriptionCodeText}>values.yaml</span> structures it's image fields.
                    </p>
                    <p className={styles.descriptionText}>
                        Open your chart's <span className={styles.descriptionCodeText}>values.yaml</span> to find the exact path. Use dot notation from the root to the tag field.
                    </p>
                </div>}/>);
}
